import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const SVG = ({
  className = '',
  size = '24'
}) => ___EmotionJSX("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: size,
  height: size,
  className: className,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, ___EmotionJSX("path", {
  d: "M4 14h6"
}), ___EmotionJSX("path", {
  d: "M4 2h10"
}), ___EmotionJSX("rect", {
  x: "4",
  y: "18",
  width: "16",
  height: "4",
  rx: "1"
}), ___EmotionJSX("rect", {
  x: "4",
  y: "6",
  width: "16",
  height: "4",
  rx: "1"
}));
export default SVG;